import { ICustomAnimationProps } from "@thekilroygroup/shared-ui";
import theme from "theme";

export const backgroundAnimations: ICustomAnimationProps = {
  type: "fade",
  delay: 300,
  delayOut: 300,
  timeout: { enter: 300, exit: 300 },
};

export const headerAnimations: ICustomAnimationProps = {
  type: "collapse",
  delay: 250,
  delayOut: 250,
  timeout: { enter: 250, exit: 100 },
  direction: "down",
  mountOnEnter: true,
  easing: theme.transitions.easing.easeIn,
};

export const fadeInButtons: ICustomAnimationProps = {
  type: "fade",
  timeout: { enter: 1000, exit: 250 },
  delay: 750,
  easing: theme.transitions.easing.easeOut,
};

export const fadeInCard: ICustomAnimationProps = {
  type: "fade",
  timeout: { enter: 1000, exit: 250 },
  easing: theme.transitions.easing.easeOut,
};

export const navigateDelay = 1250;
